<div
    *ngIf="pagedata?.layoutType === 'offer-toggle-banner'"
    fxShow
    fxShow.xs="false"
>
    <mat-sidenav-container class="example-container">
        <mat-sidenav style="width: 500px; border: none" #sidenav mode="side">
            <img
                src="{{ pagedata?.layoutContent?.banner?.image }}"
                style="width: 100%"
                (click)="processLink(pagedata?.layoutContent?.banner?.link)"
            />
        </mat-sidenav>

        <mat-sidenav-content>
            <!-- <p><mat-checkbox [(ngModel)]="opened">sidenav.opened</mat-checkbox></p> -->
            <!-- <p><button (click)="sidenav.toggle()"></button></p> -->
            <img
                src="{{ pagedata?.layoutContent?.offerImage }}"
                (click)="sidenav.toggle()"
            />
            <!-- <p>Events:</p>
          <div class="example-events">
            <div *ngFor="let e of events">{{e}}</div>
          </div> -->
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>

<div
    *ngIf="pagedata?.layoutType === 'offer-toggle-banner'"
    fxShow
    fxShow.gt-xs="false"
>
    <mat-sidenav-container class="example-container-mobile">
        <mat-sidenav style="width: 300px; border: none" #sidenav mode="side">
            <img
                src="{{ pagedata?.layoutContent?.banner?.image }}"
                style="width: 100%"
                (click)="processLink(pagedata?.layoutContent?.banner?.link)"
            />
        </mat-sidenav>

        <mat-sidenav-content style="width: 23px; overflow: hidden">
            <div>
                <img
                    src="{{ pagedata?.layoutContent?.offerImage }}"
                    (click)="sidenav.toggle()"
                    width="100%"
                />
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>
